import { trackApiClient } from '@/clients/TrackApiClient';
import { ITrack } from '@/data/models/track';
import { useMutation } from '@tanstack/react-query';

export default function useUpdateTrackMutation() {
  return useMutation({
    mutationFn: async ({
      trackId,
      track,
    }: {
      trackId: number;
      track: ITrack;
    }) => {
      return await trackApiClient.updateTrack(trackId, track);
    },
  });
}
